import React from "react";
import useClx from "../../../../hooks/use-clx";
import clxs from "./per-villa-rules.module.css";
import Description from "../../../PropertyDetail/LohonoLayout/Description";

interface PerVillaRulesProps {
  className?: string;
  propertyName: string;
  description: string;
}

function PerVillaRules(props: PerVillaRulesProps) {
  const { className, propertyName, description } = props,
    ccx = useClx(clxs.container, className);
  return (
    <div className={ccx}>
      <div className={clxs.propertyName}>{propertyName}</div>
      <Description
        className={clxs.description}
        description={description}
        descriptionClassName={clxs.descriptionText}
      />
    </div>
  );
}

export default PerVillaRules;
